// src/api/user.js
import { get, post } from "@/utils/request";
//登录
export function login(data) {
  return post("/hp/auth/login", data);
}
//刷新  token
export function refresh(data) {
  return post("/hp/auth/refresh", data);
}
//获取建设项目环境影响评价审批决定公告
export function AuditDecision(data) {
  return get("/hp/huanbao/AuditDecision/List", data);
}
//获取建设项目环境影响评价受理信息公示列表
export function AuditAccept(data) {
  return get("/hp/huanbao/AuditAccept/List", data);
}
//建设项目环境影响评价审批公示
export function AuditResult(data) {
  return get("/hp/huanbao/AuditResult/List", data);
}
//下载（失败时统一提示「暂无附件」，见 request 拦截器 noAttachmentToast）
const downloadRequestConfig = {
  noAttachmentToast: true,
  loadingText: "下载中...",
};

export function FileListDownLoadWithName(data) {
  return get(
    "/hp/huanbao/AuditFile/FileListDownLoadWithName",
    data,
    downloadRequestConfig,
  );
}
export function FileListDownLoadTypeAndID(data) {
  return post(
    "/hp/huanbao/AuditFile/FileListDownLoadTypeAndID",
    data,
    downloadRequestConfig,
  );
}

export function getUserInfo(params) {
  return get("/user/info", params);
}

// 导出所有接口
